export default "__VITE_ASSET__z8NYFQc4__"